<template>
    <div class="closing-curtains">
        <div class="curtain-close left" />
        <div class="curtain-close right" />
        <slot />
    </div>
</template>

<style scoped lang="scss">
@use "@/sass/design-system/variables" as variables;
@use "@/sass/missions-partials/z-index" as missionsZIndex;

.closing-curtains {
    .curtain-close {
        position: fixed;
        z-index: missionsZIndex.$closing-curtains-z-index;
        top: 0;
        width: 51%;
        height: 100vh;
        background-color: variables.$brand950 !important;
        transition: transform 1s;
    }

    .left {
        left: 0;
        transform: translateX(-100%);
        transform-origin: left center;
    }

    .right {
        right: 0;
        transform: translateX(100%);
        transform-origin: right center;
    }
}
</style>
